//  external libraries
import { motion, MotionProps } from 'framer-motion';

export const MotionSlideIn = (props: MotionProps) => (
  <motion.div
    layout={props.layout}
    initial={{ height: 0, opacity: 0 }}
    animate={{ height: 'auto', opacity: 1 }}
    exit={{ height: 0, opacity: 0 }}
    transition={{ duration: 0.1, ease: 'easeInOut' }}
    {...props}
  >
    {props.children}
  </motion.div>
);
